import { FaClipboardCheck, FaSmile, FaAward, FaUsers } from 'react-icons/fa';

const counter = [
  {
    id: 1,
    icon: <FaClipboardCheck />, // Clipboard icon
    title: 'Projects Completed',
    count: '200',
  },
  {
    id: 2,
    icon: <FaSmile />, // Smile icon
    title: 'Satisfied Clients',
    count: '150',
  },
  {
    id: 3,
    icon: <FaAward />, // Award icon
    title: 'Design Awards Won',
    count: '10',
  },
  {
    id: 4,
    icon: <FaUsers />, // Users icon
    title: 'Expert Designers',
    count: '15',
  },
];

export default counter;